import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JpqlComponent } from '../jpql.component';

@Component({
  selector: 'large-data',
  templateUrl: './jpql-large-data.component.html',
  styleUrl: './jpql-large-data.component.scss'
})
export class JpqlLargeDataComponent {

  constructor(public dialogRef: MatDialogRef<JpqlComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { content: string }
  ) { }

}
